// Libs
import React, { Component } from 'react'
import { Container, Row, Col } from '../../components/Elemental'
import { connect } from 'react-redux'
import _ from 'lodash'

// CSS
import './styles.scss'

// Components/Containers
import FilterPanelCheckbox from './components/FilterPanelCheckbox'
import Button from '../../components/Button'

// Actions
import { changeFilterPanelVisible, toggleFilterPanelOption, toggleFilterPanelAll, fetchFilterPanelParams, fetchFilterPanelReport, resetFilterPanelParams } from './actions'
import { resetDashboardData } from '../Dashboard/actions'

class FilterPanel extends Component {
  // TODO: Change absolute date as state when release this feature to the user
  state = {
    startDay: '',
    startMonth: '',
    startYear: '',
    endDay: '',
    endMonth: '',
    endYear: '',
    intervalId: ''
  }

  componentDidMount() {
    const { user: { group, lawFirmId }, period, companies, lawFirms, regions, classifiers, fetchFilterPanelParams, fetchFilterPanelReport } = this.props

    if (_.isEmpty(period.selected)) fetchFilterPanelParams(lawFirmId, [])
    fetchFilterPanelReport(group, period, companies, lawFirms, regions, classifiers, true, false, false)

    this.intervalId = setInterval(() => {
      const { user: { group }, period, companies, lawFirms, regions, classifiers } = this.props

      // fetchFilterPanelReport(group, lawFirmId, period, companies, lawFirms, regions, classifiers, true, false)
      fetchFilterPanelReport(group, period, companies, lawFirms, regions, classifiers, true, false, true)
    }, 60000)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { user: { group, lawFirmId }, visible, fetchFilterPanelParams, fetchFilterPanelReport } = this.props
    const { user: { group: nextGroup, lawFirmId: nextLawFirmId }, visible: nextVisible } = nextProps

    if (visible !== nextVisible) {
      this._div.scrollTop = 0
    }

    if (group !== nextGroup || lawFirmId !== nextLawFirmId) {
      fetchFilterPanelParams(nextLawFirmId, [])
      fetchFilterPanelReport(nextGroup, { options: [], selected: [] }, { options: [], selected: [] }, { options: [], selected: [] }, { options: [], selected: [] }, { options: [], selected: [] }, true, false, false)
    }
  }

  componentWillUnmount() {
    const { intervalId } = this

    clearInterval(intervalId);
  }

  render() {
    const { user: { group, lawFirmId }, visible, loading, period, companies, lawFirms, regions, changeFilterPanelVisible, toggleFilterPanelOption, toggleFilterPanelAll, fetchFilterPanelReport, classifiers } = this.props
    const { startDay, startMonth, startYear, endDay, endMonth, endYear } = this.state
    let absoluteDate = ''

    if (startDay && startMonth && startYear && endDay && endMonth && endYear) {
      absoluteDate = `${startYear}-${startMonth}-${startDay}T00:00:00.000Z/${endYear}-${endMonth}-${endDay}T23:59:59.000Z`
    }

    if (visible) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "auto"
    }
    return (
      <div
        ref={(ref) => this._div = ref}
        className={visible ? "filter-panel filter-panel--visible" : "filter-panel"}>
        <Container>
          <Row>
            <Col gutter={10}>
              <div className="filter-panel__header">
                <div>
                  <p className="filter-panel__title">Painel de Opções</p>
                  <p className="filter-panel__sub-title">Selecione as opções que deseja visualizar em seu dashboard</p>
                </div>
                <div className="filter-panel__close">
                  <i className="material-icons" onClick={() => changeFilterPanelVisible(false)}>close</i>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg="1/2" className="filter-panel__col" gutter={10}>
              {/* admin &&
                <div className="filter-panel__absolute-date">
                  <input value={startDay} onChange={(e) => this.setState({startDay: e.target.value})}></input> /
                  <input value={startMonth} onChange={(e) => this.setState({startMonth: e.target.value})}></input> /
                  <input value={startYear} onChange={(e) => this.setState({startYear: e.target.value})}></input> -
                  <input value={endDay} onChange={(e) => this.setState({endDay: e.target.value})}></input> /
                  <input value={endMonth} onChange={(e) => this.setState({endMonth: e.target.value})}></input> /
                  <input value={endYear} onChange={(e) => this.setState({endYear: e.target.value})}></input>
                </div>
              */}
              <FilterPanelCheckbox
                number="1"
                title="Período"
                sub_title="Escolha o período abaixo."
                options={period.options}
                selected={period.selected}
                multiple={false}
                handleToggleOption={(option, multiple) => toggleFilterPanelOption('period', option, multiple)}
              />
            </Col>
            <Col lg="1/2" className="filter-panel__col" gutter={10}>
              <FilterPanelCheckbox
                number="2"
                title="Empresa(s)"
                sub_title="Escolha uma ou mais empresas abaixo."
                options={companies.options}
                selected={companies.selected}
                handleToggleAll={action => toggleFilterPanelAll('companies')}
                handleToggleOption={(option, multiple) => toggleFilterPanelOption('companies', option, multiple)}
              />
            </Col>
            <Col lg="1/2" className="filter-panel__col" gutter={10}>
              <FilterPanelCheckbox
                number="3"
                title="Escritório(s)"
                sub_title="Escolha um ou mais escritórios abaixo."
                options={lawFirms.options}
                selected={lawFirms.selected}
                handleToggleAll={action => toggleFilterPanelAll('lawFirms')}
                handleToggleOption={(option, multiple) => toggleFilterPanelOption('lawFirms', option, multiple)}
              />
            </Col>
            <Col lg="1/2" className="filter-panel__col" gutter={10}>
              <FilterPanelCheckbox
                number="4"
                title="Estados(s)"
                sub_title="Escolha um ou mais estados abaixo."
                options={regions.options}
                selected={regions.selected}
                handleToggleAll={action => toggleFilterPanelAll('regions')}
                handleToggleOption={(option, multiple) => toggleFilterPanelOption('regions', option, multiple)}
              />
            </Col>
            {!_.isEmpty(classifiers.options) &&
              <Col lg="1/2" className="filter-panel__col" gutter={10}>
                <FilterPanelCheckbox
                  number="5"
                  title="Classificador(es)"
                  sub_title="Escolha um ou mais classificadores abaixo."
                  options={classifiers.options}
                  selected={classifiers.selected}
                  handleToggleAll={action => toggleFilterPanelAll('classifiers')}
                  handleToggleOption={(option, multiple) => toggleFilterPanelOption('classifiers', option, multiple)}
                />
              </Col>}
          </Row>
          <Row>
            <Col lg="1/4" gutter={10}>
              <Button
                type="submit"
                localLoading={loading}
                gutterTop={15}
                onClick={() => fetchFilterPanelReport(group, period, companies, lawFirms, regions, classifiers, false, absoluteDate, false)}>Visualizar</Button>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

FilterPanel = connect(state => {
  return {
    user: state.auth.user,
    visible: state.filterPanel.visible,
    loading: state.filterPanel.loading,
    period: state.filterPanel.period,
    companies: state.filterPanel.companies,
    lawFirms: state.filterPanel.lawFirms,
    regions: state.filterPanel.regions,
    classifiers: state.filterPanel.classifiers
  }
}, { changeFilterPanelVisible, toggleFilterPanelOption, toggleFilterPanelAll, fetchFilterPanelParams, fetchFilterPanelReport, resetFilterPanelParams, resetDashboardData })(FilterPanel)


export default FilterPanel
